export default __webpack_public_path__ + "static/nagaraja-7fc7f582de4d3e73ac151b17e72aa4a0.png";